const initialState = {
  childCompanies: JSON.parse(localStorage.getItem('redux_sync_ChildCompanies')) || [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = initialState, action) {

  let payloadData

  switch (action.type) {
    case "CHILD_COMPANIES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
      }
    case "CHILD_COMPANIES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "CHILD_COMPANIES_FETCH_FULFILLED":
      payloadData = action.payload.data
      localStorage.setItem('redux_sync_ChildCompanies',JSON.stringify(payloadData))
      return {
        ...state,
        fetching: false,
        fetched: true,
        childCompanies: payloadData,
        errors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      localStorage.removeItem('redux_sync_ChildCompanies')
      return {
        ...initialState,
        childCompanies: [],
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState,
        childCompanies: [],
      }
    default:
      return state
  }


}



// WEBPACK FOOTER //
// ./src/reducers/childCompaniesReducer.js